import React from 'react';
import classnames from 'classnames';

import { makeBtStyles } from '../Theme';


const useStyles = makeBtStyles( theme => ({
  root: {
    backgroundImage: 'linear-gradient(180deg, #F7F7F7 0%, #F0F0F0 100%)',
    border: '1px solid #DDDDDD',
    borderRadius: '2px',
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.07)',
    height: '40px',
    color: '#222222',
    lineHeight: '38px',
    padding: '0 16px',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    '&:focus, &:hover, &:active': {
      color: '#222222',
      backgroundImage: 'linear-gradient(180deg, #F0F0F0 0%, #E7E7E7 100%)',
      textDecoration: 'none',
      zIndex: '1',
      outline: 'none'
    },
    '&:active': {
      backgroundImage: 'linear-gradient(180deg, #F0F0F0 100%, #F7F7F7 0%)',
    },
    '&:disabled': {
      color: '#929292',
      cursor: 'not-allowed'
    }
  }
}));

export default function Button(props:any) {
  const classes = useStyles();
  return <button {...props} className={classnames(classes.root,props.className)} />
}